import React from "react";
import "./SecretCell.css";
import { Button } from "../ui";
import { Eye, EyeOff } from "../ui/icons";

const MASK = "••••••••";

/**
 * A stored credential in a table cell: masked by default, shown only on request. The value is
 * not part of the row data (the list/detail responses never carry it): `value` is what the
 * credentials endpoint returned for this row, or what the user just typed.
 */
export default function SecretCell({
  available,
  value,
  shown,
  loading,
  failed,
  canReveal,
  onToggle,
  lang,
}) {
  if (!available) return <span className="secret-cell-empty">—</span>;
  const label = shown
    ? lang === "ar" ? "إخفاء" : "Hide"
    : lang === "ar" ? "إظهار" : "Show";
  return (
    <span className="secret-cell">
      <bdi dir="ltr" className="secret-cell-value">
        {shown && value ? value : MASK}
      </bdi>
      {canReveal && (
        <Button
          type="button"
          variant="primary"
          appearance="soft"
          size="sm"
          title={label}
          aria-label={label}
          disabled={loading}
          icon={shown ? <EyeOff size={16} /> : <Eye size={16} />}
          onClick={onToggle}
        />
      )}
      {failed && (
        <span className="secret-cell-error" role="alert">
          {lang === "ar" ? "تعذّر العرض" : "Unavailable"}
        </span>
      )}
    </span>
  );
}
